import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40bb91cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "chart-form-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "选择估值指标：", -1))
const _hoisted_4 = { class: "chart-form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "选择叠加指标：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_infoPanel = _resolveComponent("infoPanel")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_dataLoad = _resolveComponent("dataLoad")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_dataLoad, { spinning: _ctx.spinning }, {
      default: _withCtx(() => [
        (!_ctx.spinning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_a_tabs, {
                activeKey: _ctx.activeKey,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
                type: "card",
                onChange: _ctx.getBaseIndexF10ValuationTrend
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "5",
                    tab: "近五年"
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "10",
                    tab: "近十年"
                  })
                ]),
                _: 1
              }, 8, ["activeKey", "onChange"]),
              _createVNode(_component_infoPanel, {
                list: _ctx.list,
                contentRight: true
              }, null, 8, ["list"]),
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_a_radio_group, {
                  value: _ctx.chartForm.valuation,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chartForm.valuation) = $event)),
                  onChange: _ctx.setChart
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valuationList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_radio, {
                        value: item.value,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_a_radio_group, {
                  value: _ctx.chartForm.superposition,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chartForm.superposition) = $event)),
                  onChange: _ctx.getBaseIndexF10ValuationTrend
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.superpositionListRow, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_radio, {
                        value: item.value,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _createVNode(_component_Charts, {
                id: "gzxxChart",
                option: _ctx.option
              }, null, 8, ["option"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}